import React from "react"
// import SplashScreen from "../SplashScreen"
import LoginSplash from "../../components/auth/LoginSplash"

const PreLoginSplash = () => {
  return <LoginSplash />
}

export default PreLoginSplash



// WEBPACK FOOTER //
// ./src/routes/auth/PreLoginSplash.jsx